import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-obs-result',
  templateUrl: './obs-result.component.html',
  styleUrls: ['./obs-result.component.scss']
})
export class ObsResultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
